import React from "react";
import LatestPostHeader from "./LatestPostHeader";
import styles from "./LatestPosts.module.css";
import BLOG_POSTS from "../BlogPostData/BlogPosts";
import PROJECTS_LIST from "../BlogPostData/ProjectsList";
import Postitem from "./PostItem";
import ProjectItem from "../ListItems/Projectitem";
import headerStyle from "./LatestPostHeader.module.css";

const LatestPost = (props: { title: string }) => {
  // eslint-disable-next-line array-callback-return
  // const blogPost = BLOG_POSTS.slice(0, 4).map((post) =>
  //   props.title.includes("Posts") ? (
  //     <Postitem
  //       key={post.id}
  //       title={post.title}
  //       date={post.date}
  //       image={post.image}
  //       url={post.link}
  //     />
  //   ) : (
  //     <ProjectItem
  //       key={post.id}
  //       title={post.title}
  //       date={post.date}
  //       image={post.image}
  //     />
  //   )
  // );

  const blogPost = props.title.includes("Posts")
    ? BLOG_POSTS.slice(0, 4).map((post) => (
        <Postitem
          key={post.id}
          title={post.title}
          date={post.date}
          image={post.image}
          url={post.link}
        />
      ))
    : PROJECTS_LIST.slice(0, 4).map((post) => (
        <ProjectItem
          key={post.id}
          title={post.title}
          date={post.date}
          image={post.description}
          url={post.link}
        />
      ));

  return (
    <div className={styles.flexcontainer}>
      <LatestPostHeader
        demo={headerStyle.Main}
        margin={""}
        title={props.title}
      />
      <section>
        <ul className={styles.grid} style={{ paddingBottom: 50 }}>
          {blogPost}
        </ul>
      </section>
    </div>
  );
};

export default LatestPost;
